(function() {
  'use strict';
  
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.can-whey-reviews');
    if (!section) return;
    
    const lightbox = section.querySelector('.can-whey-reviews__lightbox');
    const videoIframe = lightbox.querySelector('.can-whey-reviews__video-iframe');
    const playButtons = section.querySelectorAll('[data-video-trigger]');
    const closeButtons = lightbox.querySelectorAll('[data-lightbox-close]');
    const testimonials = section.querySelector('.can-whey-reviews__testimonials');
    const testimonialCards = section.querySelectorAll('.can-whey-reviews__testimonial-card');
    
    // Open lightbox
    function openLightbox(videoId, videoHost) {
      if (!videoId) return;
      
      let videoSrc = '';
      
      switch(videoHost) {
        case 'youtube':
          videoSrc = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
          break;
        case 'vimeo':
          videoSrc = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
          break;
        case 'shopify':
          videoSrc = videoId + '?autoplay=1';
          break;
        default:
          videoSrc = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
      }
      
      videoIframe.src = videoSrc;
      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');
      
      // Focus management
      lightbox.focus();
      
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
    }
    
    // Close lightbox
    function closeLightbox() {
      lightbox.classList.remove('is-active');
      lightbox.setAttribute('aria-hidden', 'true');
      videoIframe.src = '';
      
      // Restore body scroll
      document.body.style.overflow = '';
    }
    
    // Add click handlers to play buttons
    playButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const card = button.closest('.can-whey-reviews__testimonial-card');
        const videoId = card.getAttribute('data-video-id');
        const videoHost = card.getAttribute('data-video-host');
        
        if (videoId) {
          openLightbox(videoId, videoHost);
        }
      });
      
      // Keyboard support
      button.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          button.click();
        }
      });
    });
    
    // Add click handlers to close buttons
    closeButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeLightbox();
      });
      
      // Keyboard support
      button.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          closeLightbox();
        }
      });
    });
    
    // Escape key support
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-active')) {
        closeLightbox();
      }
    });
    
    
    // Enhanced scroll functionality inspired by CodePen example
    function initializeScrollEffects() {
      if (!testimonials || testimonialCards.length === 0) return;

      // Set up responsive grid behavior (similar to React version)
      const cardCount = testimonialCards.length;
      testimonials.setAttribute('data-card-count', cardCount);
      testimonials.style.setProperty('--card-count', cardCount);

      // Intersection Observer for fade effect based on scroll position
      const observerOptions = {
        root: testimonials,
        rootMargin: '0px',
        threshold: [0, 0.25, 0.5, 0.75, 1]
      };

      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          const card = entry.target;
          const ratio = entry.intersectionRatio;
          
          // Apply opacity and scale based on intersection ratio
          if (ratio > 0.5) {
            card.style.opacity = '1';
            card.style.transform = 'scale(1)';
          } else if (ratio > 0.25) {
            card.style.opacity = '0.8';
            card.style.transform = 'scale(0.95)';
          } else {
            card.style.opacity = '0.6';
            card.style.transform = 'scale(0.9)';
          }
        });
      }, observerOptions);

      // Observe all testimonial cards
      testimonialCards.forEach(function(card) {
        observer.observe(card);
      });

      // Enhanced momentum scrolling for better mobile experience
      let isScrolling = false;
      let scrollTimeout;
      
      testimonials.addEventListener('scroll', function() {
        // Add scrolling class for CSS transitions
        if (!isScrolling) {
          testimonials.classList.add('is-scrolling');
          isScrolling = true;
        }
        
        // Clear timeout and reset scrolling state
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          testimonials.classList.remove('is-scrolling');
          isScrolling = false;
        }, 150);
      });

      // Smooth scroll to specific card on click outside the card
      testimonials.addEventListener('click', function(e) {
        if (e.target === testimonials) {
          const rect = testimonials.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const scrollX = testimonials.scrollLeft;
          const cardWidth = 320 + 24; // card width + gap
          
          const targetIndex = Math.round((clickX + scrollX) / cardWidth);
          const targetCard = testimonialCards[targetIndex];
          
          if (targetCard) {
            targetCard.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start'
            });
          }
        }
      });

      // Add keyboard navigation
      testimonials.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          
          const cardWidth = 320 + 24; // card width + gap
          const direction = e.key === 'ArrowLeft' ? -1 : 1;
          const currentScroll = testimonials.scrollLeft;
          const targetScroll = currentScroll + (direction * cardWidth);
          
          testimonials.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
          });
        }
      });

      // Make testimonials focusable for keyboard navigation
      testimonials.tabIndex = 0;
    }

    // Initialize all functionality
    initializeScrollEffects();
  });
})();